export default __webpack_public_path__ + "static/machine-learning-132e4a795a25bb0ae4fa059d65ae026b.svg";